import React from "react";
import { Widget } from '@typeform/embed-react'

const Form = () => {
  return <Widget id="MQEboNDl" className="regi-form" />
}

export default Form;